const CODE_EDITOR_ROWS_DEFAULT = 30;

export const CODE_EDITOR_STATIC_PROPS = {
  readOnly: true,
  lang: 'lua',
  rows: CODE_EDITOR_ROWS_DEFAULT,
  name: 'transformation-lib',
  testId: 'transformation-lib-code-editor',
};

function useDrawerCodeEditorProps() {
  return {
    ...CODE_EDITOR_STATIC_PROPS,
  };
}

export default useDrawerCodeEditorProps;
